import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { CloseButton, Container } from "./component/styled/common";
import { KioskMemuList } from "./component/styled/kiosk";

import { MdClose } from "react-icons/md";
import { exitFullscreen } from "./component/function/kiosk";
import { useDisableScroll } from "../../../hooks/useDisableScroll";
import { checkKioskCond } from "../dashboard/component/function/dashboard";

const KioskPage = () => {
  useDisableScroll();

  const navigate = useNavigate();

  const company = useSelector((state) => state?.company?.data);

  useEffect(() => {
    if (!checkKioskCond(company)) {
      toast.error("접근 권한이 없습니다.", { toastId: "no-access" });
      navigate("/mypage");
      return;
    }
  }, []);

  const sungsimdang = [
    { key: "storage", tit: "보관", imagePath: "sungsimdang" },
    { key: "pickup", tit: "찾기", imagePath: "sungsimdang_cake" },
    { key: "salesCheck", tit: "매출관리", imagePath: "" },
    { key: "reservationStatus", tit: "이용내역조회", imagePath: "sungsimdang_bread" },
    // { key: "coupon", tit: "쿠폰", imagePath: "sungsimdang_coupon" },
  ];

  const exitKioskPage = () => {
    exitFullscreen();
    navigate("/mypage");
  };

  return (
    <Container className="bg">
      <CloseButton>
        <button onClick={exitKioskPage}>
          <MdClose />
        </button>
      </CloseButton>
      <KioskMemuList className="sungsim">
        {sungsimdang.map((item) => (
          <li
            key={item.key}
            className={item.key}
            onClick={() => navigate(`/mypage/kiosk/${item.key}`)}>
            <div className="content">
              <div className="image">
                <img src={`/img/sungsimdang/${item.imagePath}.png`} alt="" />
              </div>
              <span>으능&성심 {item.tit}</span>
            </div>
          </li>
        ))}
      </KioskMemuList>
    </Container>
  );
};

export default KioskPage;
